import manifest from '../config/artwork-controls.json';
import { discoveredProfile } from './artworkControlConventions';

const inspected = new Map();
const resolved = new Map();

// Hash the script we are actually about to execute, including live chain reads.
// Never apply a profile solely because a project number or title matches.
async function resolveProfile(script, projectId) {
  const fallback = () => discoveredProfile(script);
  if (!manifest.profiles.some(p => p.projectId === Number(projectId))) return fallback();
  if (!window.crypto || !window.crypto.subtle) return fallback();
  if (!inspected.has(script)) {
    const digest = window.crypto.subtle.digest('SHA-256', new TextEncoder().encode(script))
      .then(bytes => Array.from(new Uint8Array(bytes), b => b.toString(16).padStart(2, '0')).join(''));
    inspected.set(script, digest);
  }
  const hash = await inspected.get(script);
  const profile = manifest.profiles.find(p => p.sha256 === hash && p.projectId === Number(projectId));
  return profile ? { ...profile, source: 'reviewed' } : fallback();
}

export default function artworkControlProfile(script, projectId) {
  if (!resolved.has(script)) resolved.set(script, new Map());
  const projects = resolved.get(script), id = Number(projectId);
  if (!projects.has(id)) projects.set(id, resolveProfile(script, id).catch(() => discoveredProfile(script)));
  return projects.get(id);
}
